import { z } from "zod";
export const reminderStatusSchema = z.enum([
    "pending",
    "sent",
    "failed",
    "cancelled",
]);
export const reminderChannelSchema = z.enum(["email"]);
export const reminderInputSchema = z.object({
    userId: z.string().min(1),
    title: z.string().min(1).max(500),
    remindAt: z.string().min(1),
    linkedTaskId: z.string().optional(),
    status: reminderStatusSchema.default("pending"),
    channel: reminderChannelSchema.default("email"),
});
export const reminderSchema = reminderInputSchema.extend({
    id: z.string().min(1),
    createdAt: z.string().min(1),
    updatedAt: z.string().min(1),
    sentAt: z.string().optional(),
    scheduleArn: z.string().optional(),
    scheduleName: z.string().optional(),
});
//# sourceMappingURL=reminder.js.map